// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeletedByMeBubble__content-f889fa {
  background-color: inherit;
}

.DeletedByMeBubble__bubble-eeb61d {
  padding: 10px 12px 0;
}

.DeletedByMeBubble__bubble-eeb61d:after {
  content: "";
  display: table;
  clear: both;
}

.DeletedByMeBubble__sender-name-a526e3 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.DeletedByMeBubble__sender-name-a526e3.DeletedByMeBubble__wide-gap-dfeb00 {
  margin-bottom: 4px;
}

.DeletedByMeBubble__thread-button-af14f0 {
  margin: 0 -12px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/DeletedByMeBubble/DeletedByMeBubble.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,eAAA;AAAF","sourcesContent":[".content {\n  background-color: inherit;\n}\n\n.bubble {\n  padding: 10px 12px 0;\n}\n\n.bubble:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &.wide-gap {\n    margin-bottom: 4px;\n  }\n}\n\n.thread-button {\n  margin: 0 -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `DeletedByMeBubble__content-f889fa`,
	"bubble": `DeletedByMeBubble__bubble-eeb61d`,
	"sender-name": `DeletedByMeBubble__sender-name-a526e3`,
	"senderName": `DeletedByMeBubble__sender-name-a526e3`,
	"wide-gap": `DeletedByMeBubble__wide-gap-dfeb00`,
	"wideGap": `DeletedByMeBubble__wide-gap-dfeb00`,
	"thread-button": `DeletedByMeBubble__thread-button-af14f0`,
	"threadButton": `DeletedByMeBubble__thread-button-af14f0`
};
module.exports = ___CSS_LOADER_EXPORT___;
